<template>
  <div class="flex flex-col">
    <div class="flex items-center justify-between mb-4">
      <slot />
      <div class="flex items-center gap-2">
        <el-input
          placeholder="Search..."
          prefix-icon="el-icon-search"
          class="w-[250px]"
          clearable
          v-model="queryParams.search"
        />
        <el-button icon="el-icon-refresh" @click="refreshList" />
      </div>
    </div>
    <div
      class="flex flex-col ring-offset-background focus-visible:outline-hidden focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 h-full overflow-auto"
    >
      <div
        class="flex-1 flex flex-col rounded-lg border bg-card text-card-foreground shadow-2xs"
      >
        <div class="flex-1 flex flex-col relative overflow-hidden">
          <div
            class="grid items-center font-semibold border-b p-3"
            style="
              grid-template-columns: 2fr 2fr 1.2fr 2fr 1.2fr 1.2fr 1.5fr;
              gap: 1rem;
            "
          >
            <div>Content</div>
            <div>Timestamp</div>
            <div>Params</div>
            <div>Notification ID</div>
            <div>Type</div>
            <div>Camera ID</div>
            <div>Actions</div>
          </div>
          <div class="flex-1 flex flex-col relative overflow-hidden">
            <SmartInfiniteCursorScroll
              :loadMethod="listNotifications"
              :pageSize="20"
              listField="notificationList"
              class="absoute inset-0"
              :queryParams="queryParams"
              ref="smartInfiniteCursorScrollRef"
            >
              <template #default="{ item }">
                <div
                  v-if="item"
                  class="grid items-center border-b py-2 px-3"
                  style="
                    grid-template-columns: 2fr 2fr 1.2fr 2fr 1.2fr 1.2fr 1.5fr;
                    gap: 1rem;
                  "
                >
                  <div
                    class="font-semibold truncate"
                    :title="item.content || '--'"
                  >
                    {{ item.content || "--" }}
                  </div>
                  <div class="truncate" :title="item.timestamp || '--'">
                    {{ item.timestamp || "--" }}
                  </div>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    :content="JSON.stringify(item.params)"
                    placement="top"
                  >
                    <div class="truncate">
                      {{ item.params }}
                    </div>
                  </el-tooltip>
                  <div class="truncate" :title="item.notification_id || '--'">
                    {{ item.notification_id || "--" }}
                  </div>
                  <div class="truncate" :title="item.type || '--'">
                    {{ item.type || "--" }}
                  </div>
                  <div class="truncate" :title="item.params?.cameraId ?? '--'">
                    {{ item.params?.cameraId ?? "--" }}
                  </div>
                  <div class="truncate">
                    <el-button
                      size="mini"
                      @click="handleViewDetail(item)"
                      icon="el-icon-more"
                    />
                  </div>
                </div>
              </template>
            </SmartInfiniteCursorScroll>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { listNotifications } from "@/api";
import SmartInfiniteCursorScroll from "./SmartInfiniteCursorScroll.vue";

export default {
  name: "AlertHistory",
  components: {
    SmartInfiniteCursorScroll,
  },
  data() {
    return {
      queryParams: {
        search: "",
      },
    };
  },
  methods: {
    listNotifications,
    async handleViewDetail(row) {
      await this.$loaderWindow({
        title: `View Alert Detail`,
        component: () => import("./DetailHistoryAlert.vue"),
        width: "70%",
        showHeader: false, // skill: showTitleBar -> showHeader
        padding: false,
        closeOnClickModal: true,
        closeOnPressEscape: false,
        props: { item: row },
      });
    },
    async refreshList() {
      await this.$refs.smartInfiniteCursorScrollRef.refresh();
    },
  },
};
</script>
